import { Box, SxProps } from '@mui/material';
import { ReactNode } from 'react';
import * as React from 'react';

import { LoadingView } from '~/scenes/PortalViews/components/LoadingView';
import { mergeSxProps } from '~/utils/helpers/sxProps';

import { useSxStyles } from './useStyles';

type PropsType = {
  sidebar?: ReactNode;
  children?: ReactNode;
  isLoadingContent?: boolean;
  sx?: SxProps;
};
export const SidebarLayout = (props: PropsType) => {
  const { sidebar, children, isLoadingContent, sx } = props;

  const sxStyles = useSxStyles();

  return (
    <Box sx={mergeSxProps(sxStyles.root, sx)}>
      <Box sx={sxStyles.sidebar}>{sidebar}</Box>
      <Box sx={sxStyles.content}>
        {isLoadingContent ? <LoadingView /> : children}
      </Box>
    </Box>
  );
};
